<template>
  <section id="purchase-sheet-layout">
    <product-purchase-sheet
      :products="products"
      :coursePage="coursePage"
      :buttonLabel="buttonLabel"
      v-if="this.contentLoaded"
    />
    <system-modal :content="systemModalContent" />
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SystemModal from './components/system-modal.vue';
import ProductPurchaseSheet from './views/product-purchase-sheet.vue';
export default {
  name: 'purchase-sheet-app',
  props: ['pageId', 'courseId', 'buttonLabel'],
  components: { SystemModal, ProductPurchaseSheet },
  computed: { ...mapState(['products', 'coursePage', 'systemModalContent']) },
  methods: { ...mapActions(['setCourseProducts', 'clearSystemModalContent']) },
  created() {
    this.setCourseProducts({ pageId: this.pageId, courseId: this.courseId });
  },
  watch: {
    products() {
      this.contentLoaded = true;
    },
  },
  data() {
    return {
      contentLoaded: false,
    };
  },
};
</script>
